module.exports = __webpack_public_path__ + "img/hero-404.28cc4464.svg";